import React from "react"

const Testimonials = (props) => {
  return (
    <div id='company-portfolio'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2>Companies We Deal With</h2>
          <p>
            Products from respective industry leaders under one shed
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className='col-md-4'>
                  <div className='testimonial'>
                    <div className='testimonial-image'>
                      {' '}
                      <img src={d.img} alt='' />{' '}
                    </div>
                    <div className='testimonial-content'>
                      {/* <p>{d.text}</p> */}
                      <div className='testimonial-meta'>{d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  )
}

export default Testimonials;